import { API_GET, API_POST, API_PUT } from "../config/axiosConfig";

export const getAllClientsTag = async () => {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients/client-tags`);
        if (response?.status === 200) {
            return response?.data?.clientTags || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching clients tags:", error);
        return [];
    }
};

export const getClientTagByName = async (tagName) => {
    try {
        const response = await API_GET(
            `${process.env.REACT_APP_CORE_API_URI}/web/clients/client-tags/${encodeURIComponent(tagName)}`
        );
        if (response?.status === 200) {
            return response?.data || null;
        }
        return null;
    } catch (error) {
        console.error("Error fetching client tag by name:", error);
        return null;
    }
};

export const updateClientTag = async (data, presetId) => {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/client-tags/settings/popups/${presetId}`;
        const response = await API_PUT(url, data);
        if (response?.status === 200 || response?.status === 201) {
            return response;
        }
        throw new Error("Failed to update client tag");
    } catch (error) {
        console.error("Error updating client tag:", error);
        throw error;
    }
}

export const addClientTag = async (tagState, tagSettingState, tagPopupState) => {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/client-tags/settings/popups`;
        const { clientTag, clientTagMeta } = tagState;
        const data = {
            clientTag, clientTagMeta,
            "ClientTagSettings": tagSettingState,
            "clientTagPopups": tagPopupState,
        };
        const response = await API_POST(url, data);
        return response;
    } catch (error) {
        console.error("Error adding client tag:", error);
        throw error;
    }
};

export const addRoomAndAchievementByClientTag = async (bodyData, clientTag) => {
    try{
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/client-tags/rooms/achievements/${clientTag}`;
        const response = await API_POST(url, bodyData);
        return response;
    } catch (error) {
        console.error("Error adding client tag: ", error);
        throw error;
    }
}



export const getAllRoomPreset = async () => {
    try {
        // console.log("console log url", `${process.env.REACT_APP_CORE_API_URI}/web/clients/room-presets`);
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients/room-presets`);
        if (response?.status === 200) {
            return response?.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching room Preset:", error);
        return [];
    }
};

export const addRoomPreset = async (presetData) => {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/room-presets`;
        const respAxios = await API_POST(url, presetData);
        return respAxios;
    } catch (error) {
        console.error("Error adding room Preset:", error);
        return [];
    }
};

export const updateRoomPreset = async (presetId, presetData) => {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/room-presets/${presetId}`;
        const respAxios = await API_PUT(url, presetData);
        return respAxios;
    } catch (error) {
        console.error("Error adding room Preset:", error);
        return [];
    }
};

export const getUnityPopups = async () => {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients/unity-popups`);
        if (response?.status === 200) {
            return response?.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching unity popups:", error);
        return [];
    }
};

export const getAllKeybinds = async () => {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/keybindsOptions`);
        if (response?.status === 200) {
            return response?.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching keybinds:", error);
        return [];
    }
};
